import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import DealsInfo from './DealsInfo';
import { BoltIcon } from './Icons';

/** A deal as pushed by the bot over the `loadData` socket event. Prices are strings like "$12.99". */
export interface Deal {
  asin: string;
  title: string;
  image: string;
  timestamp: string;
  url: string;
  ninetyDayAvg: string;
  cost: string;
}

interface DealsProps {
  data: Deal[];
}

function parsePrice(price: string): number {
  return Number(price?.split('$')[1]);
}

export default function Deals (props: DealsProps) {
  return (
    <>
      <section className="dealsIntro">
        <span className="heroEyebrow">Updated as our team finds them</span>
        <h1>Latest deals</h1>
        <p className="dealsNote">Note: Strikethrough prices are based on the average price of that particular product. The strikethrough and list price are subject to change. DCThriftShop.com may earn commission via any product purchased through our website.</p>
        <p className="dealsNote">Please do not share our affiliate link URLs with others. If you wish to share our products, please share our page or remove our affiliate tracking info from the url</p>
      </section>
      {props.data.length === 0 && (
        <div className="dealsEmpty">
          <BoltIcon className="dealsEmptyIcon" />
          <h2>No live deals right now</h2>
          <p>New deals show up here as soon as our team approves them. Check back soon, or catch up on our latest tips.</p>
          <Link to="/tips" className="btn btn-ghost">Read shopping tips</Link>
        </div>
      )}
      <div className="dealGrid">
        {props.data.map((deal: Deal) => {
          const avg: number = parsePrice(deal.ninetyDayAvg);
          const cost: number = parsePrice(deal.cost);
          return (
            <Card key={deal.asin} className="dealCard">
              <span className="cardSavings">${Math.round(avg - cost)} off</span>
              <div className="dealImageWrap">
                <img className="dealImage" src={deal.image} alt={deal.title} loading="lazy" />
              </div>
              <div className="dealBody">
                <p className="dealTitle" title={deal.title}>{deal.title}</p>
                <div className="dealPrice">
                  <span className="dealNow">{deal.cost}</span>
                  <span className="dealWas">${avg}</span>
                </div>
                <a className="btn btn-primary dealCta" href={`https://amazon.com/dp/${deal.asin}/ref=nosim?tag=dcthrift-20`} target="_blank" rel="noopener noreferrer sponsored">View on Amazon</a>
                <p className="dealDate">
                  Deal discovered {new Date(deal.timestamp).toLocaleString().replace(',', '')} - <DealsInfo />
                </p>
              </div>
            </Card>
          );
        })}
      </div>
    </>
  );
};
